import { useEffect, useState } from "react";
import api from "../../../../Component/axios";

export const useEtiqueta = (id_tipo_caja, id_tipo_etiqueta) => {
  const [etiqueta, setEtiqueta] = useState([]);

  useEffect(() => {
    const getEtiqueta = async () => {
      const token = localStorage.getItem("@Token");
      try {
        const response = await api.get(`api/etiquetas/etiqueta/`, {
          params: { id_tipo_caja, id_tipo_etiqueta },
          headers: {
            Authorization: "Token " + token,
          },
        });
        setEtiqueta(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    getEtiqueta();
  }, [id_tipo_caja, id_tipo_etiqueta]);

  return { etiqueta };
};
